// utilities/searchIntents.js

export const qrCategories = [
  {
    id: "intro", label: "معرفی شخصی", icon: "mdi-account-circle-outline",
    color: "#FF8008", matches: ["personal", "social"],
  },
  {
    id: "content", label: "محتوا و لینک", icon: "mdi-multimedia",
    color: "#526D82", matches: ["media", "link"],
  },
  {
    id: "commerce", label: "فروش و تجارت", icon: "mdi-storefront-outline",
    color: "#A53860", matches: ["ecommerce", "business"],
  },
  {
    id: "service", label: "خدمات", icon: "mdi-face-agent", 
    color: "#3674B5", matches: ["service", "utility"],
  },
];

export const activeQRCategories = [
  /* ------------------- ۱. کارت ویزیت و ارتباطی ------------------- */
  {
    categories: ["personal", "business"], 
    name: "کارت ویزیت الکترونیکی",
    nameKey: "categories.electronic_business_card",
    route: "qr.cardVisit",
    icon: "mdi-card-account-details-outline",
    colors: ["#FF8008", "#FFC837", "#FF8008"],
    fadedcolors: ["#FF800833", "#FFC83733", "#FF800833"],
    keywords: [
  "کارت ویزیت", "کارت ویزیت دیجیتال", "کارت ویزیت الکترونیکی", "کارت ویزیت آنلاین", "کارت ویزیت مجازی", "کارت تماس", "کارت ارتباطی", "اطلاعات تماس", "مشخصات تماس", "شماره تلفن", "شماره موبایل", "راه ارتباطی", "ذخیره شماره", "ذخیره مخاطب","افزودن مخاطب", "افزودن به مخاطبین", "دفترچه تلفن", "معرفی خودم", "معرفی شخصی", "پروفایل شخصی", "پروفایل کاری", "اطلاعات شخصی", "نام و شماره", "شماره و آدرس", "vcard", "vcf", "contact card", "digital business card", "electronic business card", "business card", "save contact", "add contact", "contact information", "card visit", "cardvisit", "kart vizit", "kart-e vizit", "کارت ویزیت", "شماره تلفن", "تماس", "vcard", "پروفایل", "سیو", "مخاطب", "کارت الکترونیکی"
]
  },
  {
    categories: ["personal", "business"],
    name: "کارت ویزیت پرو",
    nameKey: "categories.electronic_business_card_pro",
    route: "qr.cardVisitPro",
    icon: "mdi-card-account-details-outline",
    colors: ["#F8983E", "#BC9942", "#B9712D"],
    fadedcolors: ["#F7AD6933", "#F8D06B33", "#FC963733"],
    pro: true,
  keywords: [
    "کارت ویزیت پرو",
    "کارت ویزیت حرفه ای",
    "کارت ویزیت پیشرفته",
    "کارت ویزیت کامل",
    "پروفایل حرفه ای",
    "معرفی حرفه ای",
    "رزومه",
    "رزومه آنلاین",
    "رزومه دیجیتال",
    "cv",
    "curriculum vitae",
    "portfolio",
    "نمونه کار",
    "معرفی سوابق کاری",
    "کارت ویزیت با فیلم",
    "کارت ویزیت ویدئویی",
    "کارت ویزیت چند زبانه",
    "کارت ویزیت صوتی",
    "افزودن صدا به کارت",
    "گالری صوتی",
    "فایل صوتی",
    "پادکست",
    "افزودن فایل pdf",
    "رزومه pdf",
    "نمایش pdf",
    "فرم درخواست",
    "فرم مشاوره",
    "ثبت درخواست",
    "نظرسنجی",
    "دریافت بازخورد",
    "باشگاه مشتریان",
    "عضویت پیامکی",
    "تنظیمات هوشمند",
    "کارت ویزیت چند زبانه",
    "professional business card",
    "business card pro",
    "digital resume",
    "online resume",
    "professional profile",
    "audio profile",
    "business card with video",
    "multilingual business card",
    "customer club",
    "feedback form",
    "consultation form",
    "pro",
    "پرو",
    "کارت ویزیت پرو", "رزومه", "پروفایل کامل", "کارت ویزیت با فیلم", "حرفه ای", "پیشرفته", "pro"
  ]
  },

  /* ------------------- ۲. شبکه‌های اجتماعی و پیام‌رسان‌ها ------------------- */
  {
    categories: ["social", "personal"],
    name: "شبکه های اجتماعی",
    nameKey: "categories.social_media",
    route: "qr.socialMedia",
    icon: "mdi-instagram",
    colors: ["#1E6F5C", "#29BB89", "#289672"],
    fadedcolors: ["#1E6F5C33", "#29BB8933", "#28967233"],
    // شبکه های اجتماعی
keywords: [
  "شبکه اجتماعی",
  "شبکه های اجتماعی",
  "صفحه شبکه اجتماعی",
  "لینک شبکه های اجتماعی",
  "لینک شبکه اجتماعی",
  "همه شبکه های اجتماعی",
  "لینک همه پیج ها",
  "لینک همه حساب ها",
  "معرفی شبکه های اجتماعی",
  "صفحه اجتماعی",
  "پروفایل اجتماعی",
  "صفحه مجازی",
  "آدرس پیج",
  "لینک پیج",
  "لینک پروفایل",
  "آیدی شبکه اجتماعی",
  "اینستاگرام",
  "لینک اینستاگرام",
  "پیج اینستاگرام",
  "تلگرام",
  "لینک تلگرام",
  "واتساپ",
  "لینک واتساپ",
  "لینکدین",
  "لینک لینکدین",
  "توییتر",
  "ایکس",
  "فیس بوک",
  "آپارات",
  "یوتیوب",
  "روبیکا",
  "روبینو",
  "ایتا",
  "بله",
  "سروش",
  "سروش پلاس",
  "گپ",
  "شبکه اجتماعی ایرانی",
  "social media",
  "social network",
  "social links",
  "social profile",
  "all social media",
  "instagram",
  "telegram",
  "whatsapp",
  "linkedin",
  "youtube",
  "facebook",
  "twitter",
  "x",
  "tiktok",
  "rubika",
  "eitaa",
  "bale",
  "soroush",
  "social",
  "شبکه اجتماعی", "سوشیال", "اینستاگرام", "تلگرام", "واتساپ", "لینکدین", "مدیا", "social", "media"
]
  },
  {
    categories: ["personal", "social"],
    name: "بله",
    nameKey: "categories.bale",
    route: "qr.bale",
    image: "/media/socialnetwork/icon/bale.webp",
    colors: ["#4CD6AE", "#3D9196", "#324A7D"],
    fadedcolors: ["#4CD6AE33", "#3D919633", "#324A7D33"],
    status: "deactive",
    keywords: ["بله", "پیام رسان بله", "شبکه اجتماعی ایرانی", "bale", "گروه بله", "کانال بله", "چت", "بانک ملی", "ارتباط"]
  },
  {
    categories: ["personal", "social"],
    name: "روبیکا",
    nameKey: "categories.robika",
    route: "qr.robika",
    image: "/media/socialnetwork/icon/robika.webp",
    colors: ["#7c25c7", "#E45153", "#F4AA32"],
    fadedcolors: ["#7c25c733", "#E4515333", "#F4AA3233"],
    keywords: ["روبیکا", "پیام رسان روبیکا", "شبکه اجتماعی", "robika", "روبینو", "پیج روبیکا", "کانال روبیکا", "گروه", "چت", "درآمدزایی"]
  },
  {
    categories: ["personal", "social"],
    name: "ایتا",
    nameKey: "categories.eitaa",
    route: "qr.eitaa",
    image: "/media/socialnetwork/icon/eitaa.webp",
    colors: ["#B84C24", "#fa8945", "#F05E28"],
    fadedcolors: ["#B84C2433", "#fa894533", "#F05E2833"],
    keywords: ["ایتا", "پیام رسان ایتا", "شبکه اجتماعی ایرانی", "eitaa", "کانال ایتا", "گروه ایتا", "ita", "چت ایتا", "فروشگاه ایتا"]
  },

  /* ------------------- ۳. هدایت و لینک‌ها ------------------- */
  {
    categories: ["personal", "link", "utility"],
    name: "لینک",
    nameKey: "categories.link",
    route: "qr.link",
    icon: "mdi-link-variant-plus",
    colors: ["#410445", "#EAE4D5", "#D76C82"],
    fadedcolors: ["#41044533", "#EAE4D533", "#D76C8233"],
    keywords: ["ارزان", "لینک", "سایت", "ادرس", "url", "وبسایت", "صفحه", "ارجاع", "لینک ساده", "مسیر یاب", "گوگل مپ", "بلد", "نشان", "website"]
  },
  {
    categories: ["link", "business"],
    name: "کلیک یار سئو",
    nameKey: "categories.link_pro",
    route: "qr.linkPro",
    icon: "mdi-bullseye-arrow",
    colors: ["#453404", "#EAE4D5", "#C9D76C"],
    fadedcolors: ["#CAD31633", "#A0E13833", "#77D76C33"],
    pro: false,
    keywords: ["گوگل", "سئو", "پیشرفته", "ریدایرکت", "آمار", "کلیک", "pro", "seo", "کوتاه کننده", "لینک هوشمند", "ردیابی", "آنالیز", "انتقال دهنده"]
  },

  /* ------------------- ۴. گالری‌ها و محتوا ------------------- */
  {
    categories: ["media"],
    name: "گالری صوتی",
    nameKey: "categories.audio_gallery",
    route: "qr.voice",
    icon: "mdi-folder-play",
    colors: ["#2B0F0F", "#2c3e50", "#593333"],
    fadedcolors: ["#2B0F0F33", "#2c3e5033", "#59333333"],
    keywords: ["صدا", "ویس", "وویس", "پادکست", "آهنگ", "موسیقی", "موزیک", "voice", "audio", "mp3", "ضبط صدا", "تبریک صوتی", "مداحی", "ترانه"]
  },
  {
    categories: ["media"],
    name: "گالری صوتی پرو",
    nameKey: "categories.audio_gallery_pro",
    route: "qr.voicePro",
    icon: "mdi-folder-play-outline",
    colors: ["#610C9F", "#DA0C81", "#940B92"],
    fadedcolors: ["#610C9F33", "#DA0C8133", "#940B9233"],
    keywords: ["گالری صوتی پرو", "پادکست حرفه ای", "صدا", "موزیک", "pro", "podcast", "آلبوم موسیقی", "پلی لیست", "playlist"]
  },
  {
    categories: ["media"],
    name: "گالری تصاویر",
    nameKey: "categories.photo_gallery",
    route: "qr.photo",
    icon: "mdi-image-area",
    colors: ["#27374D", "#9DB2BF", "#526D82"],
    fadedcolors: ["#27374D33", "#9DB2BF33", "#526D8233"],
    keywords: ["عکس", "تصویر", "گالری", "البوم", "آلبوم", "photo", "image", "pic", "gallery", "عکس محصول", "نمونه کار تصویری", "نمایشگاه", "تابلو"]
  },
  {
    categories: ["media", "business"],
    name: "گالری ویدئو",
    nameKey: "categories.video_gallery",
    route: "qr.video",
    icon: "mdi-youtube", 
    colors: ["#EE91E9", "#8ED2C7", "#EE98E9"],
    fadedcolors: ["#EE91E933", "#8ED2C733", "#EE98E933"],
    keywords: ["ویدیو", "ویدئو", "فیلم", "کلیپ", "آپارات", "یوتیوب", "video", "film", "clip", "تیزر", "آموزش ویدیویی", "معرفی تصویری", "ریلز", "aparat", "youtube"]
  },
  {
    categories: ["media", "business"],
    name: "گالری فایل PDF",
    nameKey: "categories.pdf_gallery",
    route: "qr.pdf",
    icon: "mdi-file-pdf-box",
    colors: ["#93291E", "#ED213A", "#93291E"],
    fadedcolors: ["#93291E33", "#ED213A33", "#93291E33"],
    keywords: ["پی دی اف", "فایل", "جزوه", "کتاب", "مقاله", "مستندات", "pdf", "document", "پاورپوینت", "راهنما", "دستورالعمل", "منو پی دی اف", "رزومه pdf", "فایل متنی"]
  },
  {
    categories: ["media"],
    name: "متن",
    nameKey: "categories.text",
    route: "qr.Qrtext",
    icon: "mdi-card-text-outline",
    colors: ["#0B132B", "#1C3D5A", "#06B6D4"],
    fadedcolors: ["#0B132B33", "#1C3D5A33", "#06B6D433"],
    keywords: ["متن", "نوشته", "تکست", "پیام", "یادداشت", "متن ساده", "text", "جمله", "پیام مخفی", "شعر", "دلنوشته", "توضیحات کوتاه", "کپی متن", "رمز وای فای"]
  },

  /* ------------------- ۵. لیبل و معرفی محصولات ------------------- */
  {
    categories: ["ecommerce", "business"],
    name: "لیبل طلا و جواهر",
    nameKey: "categories.gold_label",
    route: "qr.gold.label",
    icon: "mdi-gold",
    colors: ["#957541", "#FCCF5B", "#BE9639"],
    fadedcolors: ["#95754133", "#FCCF5B33", "#BE963933"],
    keywords: ["طلا", "جواهر", "لیبل طلا", "گالری طلا", "وزن", "عیار", "شناسنامه طلا", "gold", "سکه", "انگشتر", "گردنبند", "اجرت", "طلافروشی", "بارکد طلا"]
  },
  {
    categories: ["ecommerce", "business"],
    name: "لیبل محصول",
    nameKey: "categories.product_label",
    route: "qr.product.label",
    icon: "mdi-tag-multiple",
    colors: ["#220E24", "#5454C5", "#342056"],
    fadedcolors: ["#220E2433", "#5454C533", "#34205633"],
    keywords: ["برچسب", "لیبل", "لیبل محصول", "تگ", "شناسنامه", "بارکد کالا", "label", "قیمت", "اتیکت", "مشخصات فنی", "اصالت کالا", "گارانتی", "تاریخ انقضا"]
  },
  {
    categories: ["ecommerce", "business"],
    name: "معرفی محصول",
    nameKey: "categories.product_introduction",
    route: "qr.product.shop",
    icon: "mdi-archive-check",
    colors: ["#09122C", "#BE3144", "#872341"],
    fadedcolors: ["#09122C33", "#BE314433", "#87234133"],
    keywords: ["محصول", "تک محصول", "معرفی", "کالا", "خرید", "ویژگی", "product", "سبد خرید", "توضیحات کالا", "فروش تکی", "مشخصات محصول"]
  },
  {
    categories: ["ecommerce", "business"],
    name: "معرفی محصول پرو",
    nameKey: "categories.product_introduction_pro",
    route: "qr.product.productPro",
    icon: "mdi-professional-hexagon",
    colors: ["#490101", "#C9A44F", "#750404"],
    fadedcolors: ["#220E2433", "#5454C533", "#34205633"],
    keywords: ["محصول پرو", "محصول حرفه ای", "معرفی محصول", "پیشرفته", "pro", "تنوع محصول", "دیجی کالا", "فروش ویژه", "گالری محصول", "نظرات محصول"]
  },

  /* ------------------- ۶. خدمات، فروشگاه و سازمانی ------------------- */
  {
    categories: ["service", "ecommerce", "business"],
    name: "منو آنلاین",
    nameKey: "categories.online_menu",
    route: "qr.menu",
    icon: "mdi-silverware",
    colors: ["#3E3232", "#7E6363", "#503C3C"],
    fadedcolors: ["#3E323233", "#7E636333", "#503C3C33"],
    keywords: ["منو", "لیست غذا", "رستوران", "کافه", "قیمت", "خوراکی", "فست فود", "کافی شاپ", "menu", "سفارش غذا", "بارکد میز", "قلیان", "سفره خانه", "دیجیتال منو", "کافی"]
  },
  {
    categories: ["service", "ecommerce", "business"],
    name: "فروشگاه آنلاین",
    nameKey: "categories.online_store",
    route: "qr.bShop",
    icon: "mdi-storefront",
    colors: ["#3A0519", "#A53860", "#670D2F"],
    fadedcolors: ["#3A051933", "#A5386033", "#670D2F33"],
    keywords: [
  "فروشگاه",
  "فروشگاه اینترنتی",
  "فروشگاه آنلاین",
  "فروش اینترنتی",
  "خرید اینترنتی",
  "خرید آنلاین",
  "شاپ",
  "فروش",
  "محصول",
  "کالا",
  "مغازه",
  "مارکت",
  "فروشنده",
  "خرده فروشی",
  "ecommerce",
  "e-commerce",
  "online shop",
  "online store",
  "web shop",
  "store",
  "shop",
  "shopping",
  "buy",
  "purchase",
  "product",
  "market",
  "marketplace",
  "esale",
  "فروشگاه انلاین",
  "فروشگاه اينترنتي",
  "فروشگاه اينترني",
  "foroshgah",
  "foroshgah",
  "forushgah",
  "forush",
  "shop online",
  "online shopping",
  "فروشگاه", "شاپ", "خرید", "آنلاین", "محصول", "کالا", "مغازه", "فروش", "shop", "store", "آنلاین شاپ", "فروشگاه اینترنتی", "بوتیک", "مزون", "هایپرمارکت", "پیج فروشگاهی"]
  },
  {
    categories: ["service", "business"],
    name: "نوبت دهی و رزرو",
    nameKey: "categories.appointment_booking",
    route: "qr.appointment",
    icon: "mdi-calendar-month",
    colors: ["#7E6363", "#9B86BD", "#7776B3"],
    fadedcolors: ["#7E636333", "#9B86BD33", "#7776B333"],
    keywords: ["نوبت دهی", "رزرو", "وقت", "نوبت", "ویزیت", "پزشک", "آرایشگاه", "کلینیک", "زمانبندی", "appointment", "دکتر", "مطب", "سالن زیبایی", "نوبت آنلاین", "وقت قبلی", "تایم", "مشاوره"]
  },
  {
    categories: ["business", "ecommerce", "media"],
    name: "کاتالوگ",
    nameKey: "categories.catalog",
    route: "qr.catalog",
    icon: "mdi-notebook",
    colors: ["#0093E9", "#80D0C7", "#0093E9"],
    fadedcolors: ["#0093E933", "#80D0C733", "#0093E933"],
    keywords: ["کاتالوگ", "بروشور", "مجله", "ژورنال", "معرفی", "کالا", "نمونه کار", "catalog", "portfolio", "پورتفولیو", "کالکشن", "لیست محصولات", "آلبوم کار", "نمایشگاه"]
  },
  {
    categories: ["personal", "business"],
    name: "سایت شخصی / شرکتی",
    nameKey: "categories.personal_company_website",
    route: "qr.bPage",
    icon: "mdi-store",
    colors: ["#3674B5", "#A1E3F9", "#578FCA07"],
    fadedcolors: ["#3674B533", "#A1E3F933", "#578FCA33"],
    keywords: ["سایت شخصی", "شرکت", "شرکتی", "کسب و کار", "بیزینس", "پروفایل", "رزومه", "business", "company", "درباره ما", "معرفی شرکت", "استارتاپ", "لندینگ", "کارخانه", "صنعت"]
  },
  {
    categories: ["business", "ecommerce"],
    name: "سایت مدیریت تجاری",
    nameKey: "categories.commercial_admin_website",
    route: "qr.cPage",
    icon: "mdi-office-building",
    colors: ["#006A71", "#9ACBD0", "#48A6A7"],
    fadedcolors: ["#006A7133", "#9ACBD033", "#48A6A733"],
    keywords: ["تجاری", "شرکت", "ساختمان", "مجتمع", "اداری", "مدیریت", "commercial", "admin", "پاساژ", "برج", "هیئت مدیره", "اطلاعیه ساختمان", "املاک", "شارژ ساختمان"]
  },
  {
    categories: ["business", "ecommerce", "service"],
    name: "مولتی کارت",
    nameKey: "categories.multi_card",
    route: "qr.card",
    icon: "mdi-credit-card-multiple",
    colors: ["#21ff08", "#7df661", "#21ff08"],
    fadedcolors: ["#21ff0833", "#7df66133", "#21ff0833"],
    comingSoon: false,
    keywords: ["لینکدونی", "چند لینک", "بیزینس پیج", "سایت شخصی", "مولتی کارت", "کارت", "لینک ها", "multi", "کارت ویزیت", "کارت ویزیت هوشمند", "ارتباط با ما", "شماره تماس", "تلفن", "شبکه های اجتماعی", "nfc", "vcard", "وی کارت", "زیلینک"]
  },
  {
    categories: ["service", "business", "utility"],
    name: "فرم مشاوره",
    nameKey: "categories.consultation_form",
    route: "qr.consultationQr",
    icon: "mdi-list-box-outline",
    colors: ["#A87676", "#E1ACAC", "#CA8787"],
    fadedcolors: ["#A8767633", "#E1ACAC33", "#CA878733"],
    keywords: ["مشاوره", "فرم", "درخواست", "ثبت نام", "پرسشنامه", "اطلاعات", "consultation", "تماس با ما", "جمع آوری اطلاعات", "فرم آنلاین", "رزومه ساز", "استخدام"]
  },
  {
    categories: ["service", "business", "utility"],
    name: "فرم نظرسنجی",
    nameKey: "categories.feedback",
    route: "qr.feedback",
    icon: "mdi-comment-quote",
    colors: ["#EB5A3C", "#FFCDB2", "#E5989B"],
    fadedcolors: ["#EB5A3C33", "#FFCDB233", "#E5989B33"],
    keywords: ["نظرسنجی", "فیدبک", "نظر", "انتقاد", "پیشنهاد", "فرم", "رضایت", "feedback", "شکایات", "پشتیبانی", "ارزیابی", "رضایت سنجی", "مشتری", "صندوق انتقادات"]
  },
  {
    categories: ["service", "business", "utility"],
    name: "اپلیکیشن",
    nameKey: "categories.application",
    route: "qr.application",
    icon: "mdi-application-braces-outline",
    colors: ["#000000", "#253900", "#08CB00"],
    fadedcolors: ["#00000033", "#25390033", "#08CB0033"],
    keywords: ["اپلیکیشن", "برنامه", "نرم افزار", "دانلود اپ", "اندروید", "ios", "نصب", "apk", "app", "بازار", "مایکت", "گوگل پلی", "اپ استور", "لینک دانلود", "بازی"]
  },
  {
    categories: ["service", "ecommerce"],
    name: "گردونه شانس",
    nameKey: "categories.luck_wheel",
    route: "qr.luckWheel",
    icon: "mdi-clover-outline",
    colors: ["#A72703", "#FCB53B", "#FFE797"],
    fadedcolors: ["#A7270333", "#FCB53B33", "#FFE79733"],
    keywords: ["گردونه شانس", "قرعه کشی", "جایزه", "تخفیف", "بازی", "شانس", "گردونه", "wheel", "luck", "کد تخفیف", "کمپین", "جشنواره", "لاتاری", "قرعه", "هدیه شانسی"]
  },
  {
    categories: ["service", "ecommerce", "business"],
    name: "فروش بیمه آنلاین",
    nameKey: "categories.online_insurance_sales",
    route: "qr.insurance",
    icon: "mdi-shield-account-outline",
    colors: ["#8C0000", "#BD2000", "#FA1E0E"],
    fadedcolors: ["#8C000033", "#BD200033", "#FA1E0E33"],
    keywords: ["بیمه", "فروش بیمه", "نماینده بیمه", "عمر", "بدنه", "شخص ثالث", "تامین", "insurance", "صدور بیمه", "تمدید بیمه", "کارگزاری", "بیمه ایران", "آسیا", "پاسارگاد", "دی"]
  },
  {
    categories: ["personal", "media"],
    name: "قاب خاطره",
    nameKey: "categories.gift",
    route: "qr.gift",
    icon: "mdi-hand-heart-outline",
    colors: ["#8A151B", "#E3242B", "#99592A"],
    fadedcolors: ["#8A151B33", "#E3242B33", "#99592A33"],
    keywords: ["هدیه", "گیفت", "کادو", "جایزه", "تبریک", "کارت هدیه", "عیدی", "gift", "تولد", "سالگرد", "سوپرایز", "سورپرایز", "یادگاری", "ولنتاین", "مراسم", "کارت پستال"]
  },
    {
          categories: ["personal", "media"],
          nameKey: "categories.bankcard",
          value: "bankcard",
          route: "qr.bankcards",
          name: "کیوکارت",
          icon: "mdi-credit-card-outline", 
          colors: ["#1A237E", "#303F9F", "#E8EAF6"],
          fadedcolors: ["#00020D33", "#242D6C33", "#B1BDFE33"],
         keywords: ["پرداخت", "pay", "نقد", "بانک شهر", "صادرات", "ملت", "ملی", "bank", "card", "واریز", "کارت به کارت", "شماره کارت", "شماره حساب", "واریز", "پول", "کارت بانکی"]
        },
];

export const stopWords = [
  "کیوار", "کیوآر", "کیو", "آر", "qr", "qrcode", "بارکد", "کد", "لینک",
  "میخوام", "میخام", "خواهم", "خوام", "بسازم", "بزنم", "کنم", "کنید", "کن", 
  "کردن", "کرد", "دارم", "داریم", "هست", "است", "نیست", "باشه", "شدن", "بشه",
  "چطوری", "چطور", "چگونه", "چجوری", "دنبال", "میگردم", "بگردم",
  "طراحی", "ساخت", "ایجاد", "تولید", "درست", "نمونه", "مدل", "انواع", "روش", "لطفا", "لطفاً",
  "یه", "یک", "برای", "به", "در", "از", "با", "بر", "روی", "توی", "تو",
  "این", "آن", "اون", "همین", "همان", "من", "ما", "شما", "او", "آنها",
  "که", "را", "رو", "تا", "هم", "هر", "خود", "یا", "و", "اما", "ولی", "پس", "اگر", "اگه",
  "ها", "های", "ی", "می"
];
